var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-right-circle-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 278.108,
    height: 278.109,
    viewBox: "0 0 278.108 278.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M278.109,139.054A139.054,139.054,0,1,1,139.054,0,139.054,139.054,0,0,1,278.109,139.054Zm-145.2,46a8.7,8.7,0,1,0,12.306,12.306l52.145-52.145a8.691,8.691,0,0,0,0-12.306L145.211,80.76A8.7,8.7,0,1,0,132.9,93.066l37.313,37.3H86.909a8.691,8.691,0,1,0,0,17.382h83.309L132.9,185.05Z",
    fill: "#0081ff",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircleFill);
export default __webpack_public_path__ + "static/media/arrow-right-circle-fill.eb7f69c8546590b1ac16188a387fdaab.svg";
export { ForwardRef as ReactComponent };